<div style="display: flex;flex-direction: row; flex-wrap: wrap;justify-content: space-around;">

  <div class="canvas-style">
    <span class="title">{{debutSemaine | date:"dd/MM/YYYY"}} -- {{finSemaine | date:"dd/MM/YYYY"}}</span>
    <canvas #rdvCanvas width="423" height="320"></canvas>
  </div>
  <app-rounder-rdv></app-rounder-rdv>

</div>